<script context="module">
  import alert from "../assets/icons/alert.svelte";
  import arrowLeft from "../assets/icons/arrowLeft.svelte";
  import arrowRight from "../assets/icons/arrowRight.svelte";
  import arrowUpRight from "../assets/icons/arrowUpRight.svelte";
  import caretDown from "../assets/icons/caretDown.svelte";
  import caretUp from "../assets/icons/caretUp.svelte";
  import check from "../assets/icons/check.svelte";
  import close from "../assets/icons/close.svelte";
  import facebook from "../assets/icons/facebook.svelte";
  import filter from "../assets/icons/filter.svelte";
  import instagram from "../assets/icons/instagram.svelte";
  import linkedIn from "../assets/icons/linkedIn.svelte";
  import menu from "../assets/icons/menu.svelte";
  import pause from "../assets/icons/pause.svelte";
  import play from "../assets/icons/play.svelte";
  import playOffset from "../assets/icons/playOffset.svelte";
  import search from "../assets/icons/search.svelte";
  import threads from "../assets/icons/threads.svelte";
  import youtube from "../assets/icons/youtube.svelte";
  import x from "../assets/icons/x.svelte";

  export const ICON_NAMES = {
    alert,
    arrowLeft,
    arrowRight,
    arrowUpRight,
    caretDown,
    caretUp,
    check,
    close,
    facebook,
    filter,
    instagram,
    linkedIn,
    menu,
    pause,
    play,
    playOffset,
    search,
    threads,
    youtube,
    x
  };
</script>

<script>
  import { validatePropValue } from "../utilities/logs";

  /** Primarily used for testing
   * @type {string} */
  export let id = null;

  /**
   * The name of the icon to be rendered.
   * It should match one of the keys in the ICON_NAMES object.
   * @type {keyof typeof ICON_NAMES}
   */
  export let name = undefined;

  /** Without this tag, the size will be whatever is the enclosing container
   * @type {boolean} */
  export let inheritSize = false;

  /**
   * An optional CSS class to be applied to the icon.
   * @type {string}
   */
  export let iconClass = "";

  /**
   * The component that will be rendered as the icon.
   * It is determined by the `name` prop.
   * @type {SvelteComponent}
   */
  $: component = ICON_NAMES[name];

  validatePropValue({
    componentName: "Icon",
    propName: "name",
    propValue: name,
    validPropValues: Object.keys(ICON_NAMES)
  });
</script>

<svelte:component
  this={component}
  aria-hidden="true"
  class={iconClass}
  width={inheritSize ? undefined : "16"}
  height={inheritSize ? undefined : "16"}
  {id}
/>
